import { fetchApi, fetchApiFile } from "./utils";

export const addNewLinkToPage = async (pageID, linkDetails) =>
  fetchApi("/add-link", { method: "POST", params: { pageID, linkDetails } });

export const getLinksByPageID = async (pageID) =>
  fetchApi(`/get-links?pageID=${pageID}`, { method: "GET" });

export const updateLink = async (pageID, linkDetails) =>
  fetchApi(`/update-link`, {
    method: "POST",
    params: { pageID, linkDetails },
  });

export const deleteLink = async (pageID, linkID) =>
  fetchApi(`/update-link?linkID=${linkID}&pageID=${pageID}`, {
    method: "DELETE",
  });

export const fetchMetaData = async (url) =>
  fetchApi(`/fetch-meta-data?url=${url}`, { method: "GET" });

export const uploadThumbnailPictureToAWS = async (formData) => {
  let imageUrl = await fetchApiFile(`/upload-thumbnail-picture`, {
    method: "POST",
    params: formData,
  });
  return imageUrl;
};
